import React from 'react';
import {SafeAreaView, View} from 'react-native';
import makeStyles from './styles';
import {useThemedStyles} from '../../theme';
import BloodSugarCalendar from '../../components/modules/BloodSugarCalendar';
import {
  onCalendarClose,
  DaysSelector,
  MiniCalendar,
  AllValuesSection,
} from '../ViewBloodSugarHistory/elements';

const UI = ({
  route,
  homeMode,
  navigation,
  range,
  setRange,
  setNumDays,
  calendarVisible,
  setCalendarVisible,
  notes,
  getData,
}) => {
  const styles = useThemedStyles(makeStyles);
  return (
    <SafeAreaView style={styles.fullFlex}>
      <View style={styles.headerStyle}></View>
      <DaysSelector range={range} setNumDays={setNumDays} />
      <MiniCalendar
        homeMode={homeMode}
        range={range}
        setRange={setRange}
        setCalendarVisible={setCalendarVisible}
      />
      <BloodSugarCalendar
        visible={calendarVisible}
        onClose={dates =>
          onCalendarClose(dates, range, setRange, setCalendarVisible)
        }
      />
      <View style={{margin: 24}}>
        <AllValuesSection navigation={navigation} notes={notes} getData={getData} />
      </View>
    </SafeAreaView>
  );
};

export default UI;
